<script>
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';

import differenceInCalendarYears from 'date-fns/differenceInCalendarYears';

import { preferredName } from '@/lib/agreement/filters';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import agreementValidation from '@/mixins/agreementValidation'

export default {
	props: {
		value: Object,
		testid: String,
		disabled: Boolean,
		majorityAge: {
			type: Number,
			default: 19
		}
	},
	mixins:[validationMixin,agreementValidation],
	computed: {
		age() {
			const birthdate = parseISO(this.value.birthdate);

			return (
				isValid(birthdate) &&
				differenceInCalendarYears(new Date(), birthdate)
			);
		},
		childPreferredName() {
			return preferredName(this.value);
		},
	},
	methods:{
		validateState(name) {
			const { $dirty, $error } = this.$v.value[name];
			return $dirty ? !$error : null;
		},
		triggerValidation(){
			this.$v.value.$touch()
			this.$refs['child-name-ref'].triggerValidation();
			this.$refs['child-pronouns-ref'].triggerValidation();
			this.$refs['child-of-relationship-ref'].triggerValidation();

		}
	},
	validations:{
		value:{
			birthdate:{
				required
			}
		}
	}
};
</script>

<template>
	<div class="app-input-group">
		<party-name-input-group
			v-model="value"
			label="Child's Name"
			class="mb-3 child-name-label"
			:testid="testid"
			:disabled="disabled"
			partnerId="child"
			ref="child-name-ref"
		/>
		<date-input v-model="$v.value.birthdate.$model" label="Birthdate" :testid="testid + '-dob'" :isDateFilled="validateState('birthdate')" :isValidationOn="true" :disabled="disabled"
		toolTipText='You may use the datepicker or manually enter the numbers with the "-" between each number entry (eg. 02-24-2002)'/>
		<div
			v-if="$v.value.birthdate.$error"
			class="invalid-feedback d-block col-12"
		>
			This is a required field.
		</div>
		<radio-group
			v-model="value.pronouns"
			class="mb-3"
			select
			input-cols="5"
			label="Pronouns"
			:options="[
				{ text: 'He/Him', value: 'male' },
				{ text: 'She/Her', value: 'female' },
				{ text: 'They/Them', value: 'neutral' },
			]"
			:testid="testid + '-pronouns'"
			:disabled="disabled"
			:validation="true"
			ref="child-pronouns-ref"
			
			toolTipText="Choose the pronouns that best describe how your child's preferred pronouns."/>

		<!-- radio-group, not yes-no-choice: an unanswered value must not become "No". -->
		<radio-group
			v-model="value.ofTheRelationship"
			class="mb-3"
			select
			input-cols="5"
			label="Is this child from this relationship?"
			:options="[
				{ text: 'Yes', value: true },
				{ text: 'No', value: false },
			]"
			:testid="testid + '-of-the-relationship'"
			:disabled="disabled"
			:validation="true"
			ref="child-of-relationship-ref"
			toolTipText="Answer No for a child from an earlier relationship. Only children
			of this relationship count towards whether the parties are spouses or
			common-law partners, though child support can still be payable either way."/>

		<conditional-group
			class="mt-3"
			:condition="age >= 18"
			@reset="
				value.selfSupporting = undefined;
				value.dependantReason = undefined;
			"
		>
		<div v-if="age >= majorityAge">
			<yes-no-choice
				v-model="value.selfSupporting"
				label="Is the child self-supporting?"
				class="mb-3"
				:testid="testid + '-is-self-supporting'"
				:disabled="disabled"
			/>

			<conditional-group :condition="value.selfSupporting === false">
				<input-group
					v-model="value.dependantReason"
					input-cols="8"
					label="Child remains dependant because:"
					reset-undefined
					:testid="testid + '-dependant-reason'"
					:disabled="disabled"
				/>

				<check-group
					v-model="value.applicableChildSupportAspects"
					:label="`What Child Support aspects are applicable for ${childPreferredName}`"
					class="mt-3"
					:options="[
						{ text: 'Table Amount', value: 'table-amount', attrs:{testid: testid+value} },
						{
							text: 'Special or Extraordinary Expenses',
							value: 'special-extraordinary-expenses',
						},
					]"
					:testid="testid + '-child-support-aspects'"
					:id="testid + '-child-support-aspects'"
					:disabled="disabled"
				/>
			</conditional-group>
		</div>
		</conditional-group>
	</div>
</template>
